import SafeManage from './index'
export default [
  {
    path: '/manage',
    name: 'leyousafe-manage',
    component: SafeManage
  },
]
